import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { getSocket } from "../context/socket"; // Adjust if needed
import LinkSection from "./LinkSection";
import FileSection from "./FileSection";
import ImageSection from "./ImageSection";
import MeetingSection from "./MeetingSection";

const CardTaskData = ({ cardId }) => {
    const [sections, setSections] = useState([]);

    useEffect(() => {
        const socket = getSocket();

        const fetchCardSections = () => {
            if (cardId) {
                socket.emit("get_card_sections", cardId);
            }
        };

        if (cardId) {
            fetchCardSections();

            socket.on("card_sections_response", (response) => {
                if (response.error) {
                    console.error("Error:", response.error);
                } else {
                    setSections(response.sections || []);
                }
            });

            socket.on("triggerCardUpdate", (data) => {
                if (data?.card_id === cardId) {
                    fetchCardSections();
                }
            });

            return () => {
                socket.off("card_sections_response");
                socket.off("triggerCardUpdate");
            };
        }
    }, [cardId]);





    const renderSectionContent = (section) => {
        if (section.links?.length) return <LinkSection section={section} cardId={cardId} />;
        if (section.images?.length) return <ImageSection section={section} cardId={cardId}/>;
        if (section.files?.length) return <FileSection section={section} cardId={cardId} />;
        if (section.meetings?.length) return <MeetingSection section={section} cardId={cardId}/>;

        return null; // No content
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-start mb-3">
                <h6><i className="pi pi-briefcase me-2"></i> <b>Card Task Data</b></h6>
            </div>
            <Row>
                <Col lg={12} md={12} sm={12}>
                    {sections.length > 0 ? (
                        sections.map(section => (
                            <div key={section.section_id} className="pb-3 mb-4 border-bottom">
                                {renderSectionContent(section)}
                            </div>

                        ))
                    ) : (
                        <p className="text-muted">No section data found.</p>
                    )}
                </Col>
            </Row>
        </>
    );
};

export default CardTaskData;
